/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { QuoteExtractionResultDto } from './QuoteExtractionResultDto';

export type JobStatusResponseDto = {
  /**
   * The current status of the job.
   */
  status: JobStatusResponseDto.status;
  /**
   * The result returned by the job upon successful completion. Only returned if the job has completed.
   */
  result?: QuoteExtractionResultDto;
  /**
   * The reason the job failed, if applicable. Only returned if the job has failed.
   */
  errorMessage?: Record<string, any>;
};

export namespace JobStatusResponseDto {
  /**
   * The current status of the job.
   */
  export enum status {
    ACTIVE = 'active',
    WAITING = 'waiting',
    COMPLETED = 'completed',
    FAILED = 'failed',
    DELAYED = 'delayed',
    WAITING_CHILDREN = 'waiting-children',
  }
}
